interface Props {
  [key: string]: any
}
function EncyclopediaBookIcon(props: Props): React.ReactElement {
  const { gradientStart, gradientStop, id } = props
  const FilterId = id ? id.replace("'", '') : Math.random().toString(36)
  return (
    <svg fill="none" height="45" viewBox="0 0 45 45" width="45" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M40.7295 13.4859V34.8777C40.7295 35.8663 39.9283 36.6675 38.9397 36.6675H6.37673C5.3881 36.6675 4.58691 35.8663 4.58691 34.8777V13.4859C4.58691 12.9557 4.87348 12.4674 5.33556 12.2095L5.95883 11.8608C6.34569 11.6447 6.82209 11.9241 6.82209 12.3671V30.9733C6.82209 32.0467 7.59939 32.9613 8.65848 33.1321L20.6439 35.0831C21.9776 35.3004 23.3376 35.3004 24.6713 35.0831L36.6567 33.1321C37.717 32.9601 38.4931 32.0455 38.4931 30.9733V12.3671C38.4931 11.9241 38.9695 11.6447 39.3564 11.8608L39.9797 12.2095C40.4429 12.4686 40.7295 12.9569 40.7295 13.4859Z"
        fill={`url(#paint0_linear_${FilterId})`}
      />
      <path
        d="M21.4437 34.0358L8.37888 31.8066C8.06963 31.7541 7.84277 31.4854 7.84277 31.1714V9.63513C7.84277 9.2829 8.12456 8.99514 8.47679 8.99036C10.6785 8.96051 18.0742 9.19573 22.0276 13.4297C22.1374 13.5479 22.1971 13.7055 22.1971 13.8679V33.4006C22.1971 33.7994 21.8377 34.1027 21.4437 34.0358Z"
        fill={`url(#paint1_linear_${FilterId})`}
      />
      <path
        d="M23.8721 34.0358L36.9369 31.8066C37.2461 31.7541 37.473 31.4854 37.473 31.1714V9.63513C37.473 9.2829 37.1912 8.99514 36.839 8.99036C34.6372 8.96051 27.2416 9.19573 23.2882 13.4297C23.1784 13.5479 23.1187 13.7055 23.1187 13.8679V33.4006C23.1187 33.7994 23.478 34.1027 23.8721 34.0358Z"
        fill={`url(#paint2_linear_${FilterId})`}
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint0_linear_${FilterId}`}
          x1="26.6336"
          x2="26.552"
          y1="36.6675"
          y2="11.786"
        >
          <stop stopColor={gradientStart} />
          <stop offset="1" stopColor={gradientStop} />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint1_linear_${FilterId}`}
          x1="16.5988"
          x2="16.3905"
          y1="34.0451"
          y2="8.98945"
        >
          <stop stopColor={gradientStart} />
          <stop offset="1" stopColor={gradientStop} />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`paint2_linear_${FilterId}`}
          x1="31.8747"
          x2="31.6664"
          y1="34.0451"
          y2="8.98945"
        >
          <stop stopColor={gradientStart} />
          <stop offset="1" stopColor={gradientStop} />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default EncyclopediaBookIcon
